import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreNumber } from '../../ParseHelper';
import { FilteredKeys } from '../../../Utility/Types';

export default class NumericProperty<
    TPlayerStateKey extends FilteredKeys<IPlayerState, number>,
    TPlayerDataKey extends FilteredKeys<IPlayerData, number>
>
    implements PlayerProperty<TPlayerStateKey, TPlayerDataKey>
{
    private readonly playerStateKey: TPlayerStateKey;
    private readonly playerDataKey: TPlayerDataKey;

    constructor(
        playerStateKey: TPlayerStateKey,
        playerDataKey: TPlayerDataKey,
    ) {
        this.playerStateKey = playerStateKey;
        this.playerDataKey = playerDataKey;
    }

    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return playerEndpointData[this.playerDataKey] !== playerStateData[this.playerStateKey];
    }

    public restore(playerEndpointData: IPlayerData): Restore<TPlayerStateKey> {
        return restoreNumber(playerEndpointData[this.playerDataKey], 0);
    }

    public save(playerStateData: IPlayerState): Save<TPlayerDataKey> {
        return {
            [this.playerDataKey]: playerStateData[this.playerStateKey],
        } as Pick<IPlayerData, TPlayerDataKey>;
    }
}
